// extracted by mini-css-extract-plugin
export default {"close":"CloseX_close__OZkjf"};